import React, { Component } from "react";
import "./NutritionImage.css";

class NutritionImage extends Component {
  render() {
    return (
      <div id="nImage">
        <img
          src="/images/pages/watercolor_grapes.png"
          alt="Watercolor Feather"
          id="nImageImage"
        />
      </div>
    );
  }
}

export default NutritionImage;
